import type { FilterFn } from "@tanstack/react-table";

export const numberInStringArrayFilter: FilterFn<any> = (
  row,
  columnId,
  filterValue,
) => {
  const selected = (filterValue as string[] | undefined) ?? [];
  if (selected.length === 0) return true;

  const value = row.getValue(columnId) as number | null | undefined;
  if (value === null || value === undefined) return false;

  return selected.includes(String(value));
};
